import { useQuery } from '@tanstack/react-query';
import type { LeaseLog, LogList } from '@vuokramani/shared';
import { api } from './api.ts';

const BASE = import.meta.env.VITE_API_URL ?? '/api';

/** Lokit, joihin käyttäjällä on pääsy: omat asunnot ja omat vuokrasuhteet. */
export function useLogs() {
  return useQuery({ queryKey: ['logs'], queryFn: () => api<LogList>('/logs') });
}

export function useLeaseLog(leaseId: string | undefined) {
  return useQuery({
    queryKey: ['leaseLog', leaseId],
    queryFn: () => api<LeaseLog>(`/leases/${leaseId}/log`),
    enabled: Boolean(leaseId),
    staleTime: 0,
  });
}

export const leaseLogPdfUrl = (leaseId: string) => `${BASE}/leases/${leaseId}/log.pdf`;
export const propertyLogPdfUrl = (propertyId: string) => `${BASE}/properties/${propertyId}/log.pdf`;
